module.exports = __webpack_public_path__ + "img/dark.b7d4f578.svg";